import { createRequestDataSource } from '@ngneat/elf-requests';
import { selectCurrentPageEntities } from '@ngneat/elf-pagination';

import { historiesStore } from '@store/settings/history/history.store';

export const getHistoriesDataSource = createRequestDataSource({
  store: historiesStore,
  data$: () => historiesStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getHistories',
  dataKey: 'histories',
});
